import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { filter, pipe, switchMap, tap } from 'rxjs';
import { DiagnosisSolutionService } from 'src/app/core/services/diagnosis-solution.service';
import { ReviewSelectedSolutionsState } from './review-selected-solutions.model';

const initialState: ReviewSelectedSolutionsState = {
  selectedSolutions: [],
  isLoading: false,
};

export type ReviewSelectedSolutionsStoreType = InstanceType<
  typeof ReviewSelectedSolutionsStore
>;

export const ReviewSelectedSolutionsStore = signalStore(
  withDevtools('review-selected-solutions'),
  withState(initialState),
  withMethods(
    (store, diagnosisSolutionService = inject(DiagnosisSolutionService)) => ({
      loadSelectedSolutions: rxMethod<string>(
        pipe(
          filter((diagnosisSessionId) => !!diagnosisSessionId),
          tap(() => patchState(store, { isLoading: true })),
          switchMap((diagnosisSessionId: string) =>
            diagnosisSolutionService.getSelectedSolutions(diagnosisSessionId),
          ),
          tapResponse(
            (selectedSolutions) =>
              patchState(store, { selectedSolutions, isLoading: false }),
            (error: HttpErrorResponse) => {
              console.error(
                'An error occurred in loadSelectedSolutions:',
                error,
              );
            },
            () => patchState(store, { isLoading: false }),
          ),
        ),
      ),
    }),
  ),
);
